// src/features/emailVerification/slices/verificationMethodSelectionSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { loader } from "../../../core/store/loaderSlice";

export const fetchVerificationOptions = createAsyncThunk(
	"verification/fetchOptions",
	async ({ caseId, axiosClient }, { dispatch, rejectWithValue }) => {
		try {
			dispatch(loader({ open: true, type: "options" }));
			const response = await axiosClient.get(
				`/caseInfo/${caseId}`
			);
			dispatch(loader({ open: false }));
			// return rejectWithValue({
			// 	emailVerificationId: null,
			// 	verificationMethod: null,
			// 	msisdnData: null,
			// 	emailId: null,
			// 	status: "NOT_FOUND"
			// });
			return response.data;
		} catch (err) {
			dispatch(loader({ open: false }));
			return rejectWithValue(err.response?.data);
		}
	}
);
const initialState = {
	caseInfo: {},
	loading: "pending",
	caseInfoError: null
};

const verificationMethodSelectionSlice = createSlice({
	name: "caseInfo",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchVerificationOptions.pending, (state) => {
			state.loading = "pending";
			state.caseInfoError = null;
		})
			.addCase(
				fetchVerificationOptions.fulfilled,
				(state, action) => {
					state.caseInfo = action.payload;
					state.loading = "idle";
					state.caseInfoError = null;
				}
			)
			.addCase(
				fetchVerificationOptions.rejected,
				(state, action) => {
					state.loading = "idle";
					state.caseInfo = {};
					state.caseInfoError = action.payload;
				}
			);
	}
});

export default verificationMethodSelectionSlice.reducer;
